// src/features/legal/components/Tokushoho.tsx
import React from 'react';

import './Tokushoho.css';

const Tokushoho: React.FC = () => {
  // 会社情報や連絡先は変数にしておくと管理しやすいです
  const companyName = '株式会社FLUCT'; // 正式な事業者名に修正してください
  const representativeName = 'フラクト 太郎'; // 運営統括責任者名
  const postalCode = '〒123-4567';
  const address = '東京都テスト区テスト1丁目1番1号';
  const phoneNumber = '0123-456-789';
  const receptionHours = '平日 10:00〜17:00';
  const contactEmail = 'support@example.homekarte.jp';
  const siteUrl = 'https://www.example.homekarte.jp';

  return (
    <div className="tokushoho-container">
      <h1>特定商取引法に基づく表記</h1>

      <h2>事業者名</h2>
      <p>{companyName}</p>

      <h2>運営統括責任者</h2>
      <p>{representativeName}</p>

      <h2>所在地</h2>
      <p>
        {postalCode}
        <br />
        {address}
      </p>

      <h2>電話番号</h2>
      <p>
        {phoneNumber}
        <br />
        （受付時間：{receptionHours}）
      </p>

      <h2>メールアドレス</h2>
      <p>{contactEmail}</p>

      <h2>WebサイトURL</h2>
      <p>{siteUrl}</p>

      <h2>サービス名</h2>
      <p>HomeKarte</p>

      <h2>販売価格（サービス利用料）</h2>
      <p>
        当アプリ（HomeKarte）の基本利用料は無料です。
        <br />
        リフォームおよび修繕サービス（以下「本サービス」）の料金は、お客様が依頼する各サービス提供事業者（以下「事業者」）の見積もりによります。
      </p>

      <h2>サービス利用料以外に発生する料金</h2>
      <p>
        消費税。
        <br />
        なお、本サービスをご利用の際に発生する通信料は、お客様のご負担となります。
      </p>

      <h2>お支払い方法</h2>
      <p>
        本サービスの対価は、各事業者の定める方法に従い、当該事業者に対して直接お支払いください。
        （例：銀行振込、クレジットカード、現地決済など）
      </p>

      <h2>お支払い時期</h2>
      <p>本サービスの対価は、各事業者の定める時期に従いお支払いください。</p>

      <h2>サービスの提供時期</h2>
      <p>
        お客様と各事業者との間で合意した日時・期間に、事業者によってサービスが提供されます。
      </p>

      <h2>キャンセル・返金について</h2>
      <p>
        当アプリは、お客様と事業者との間のサービス契約の場を提供するものです。
        <br />
        お客様と事業者との間で成立した契約のキャンセル、変更、または返金に関する条件は、当該事業者の定める規約または両者間の合意に従うものとします。契約内容を十分にご確認の上、事業者へ直接お問い合わせください。
        <br />
        当アプリの退会（アカウント削除）は、アカウント設定ページよりいつでも行うことができます。
      </p>

      <h2>動作環境</h2>
      <p>
        iOS 15.0 以降
        <br />
        Android 10.0 以降
      </p>
    </div>
  );
};

export default Tokushoho;
